<script lang="ts">
	import { Icon } from '$lib/components/atoms/Icon';
	import { OptionPrice, PackagePrice } from '$lib/components/atoms/Price';
	import { TooltipDesktop } from '$lib/components/atoms/Tooltip';
	import { UpsellingUtils } from '$lib/utils/upselling-store/utils';
  import type { OptionModel, PackageModel, SessionModel } from '@24hbs/utils';
  import classNames from 'classnames';

  export let selectedSession: SessionModel;
  export let packages: PackageModel[] = [];
  export let options: OptionModel[] = [];
  export let hasVatFree: boolean = false;
  export let showPriceWithIva: boolean = false;


  const staticOptions = UpsellingUtils.getStaticOptionsDesktop();

  let colsNumber: number;
  let firstColWidthClass: string;
  let colWidthClass: string;
  let otherOptions: OptionModel[];
  let firstOptions: OptionModel[];
  let mandatoryOptions: OptionModel[];
  const isSinglePackage = packages.length === 1;

  const renderTable = (selectedSession) => {
    if (!selectedSession) return;
    if (isSinglePackage) {
      firstColWidthClass = 'w-1/2';
      colWidthClass = 'w-1/2';
    } else {
      colsNumber = packages.length + 2; 
      firstColWidthClass = `w-2/${colsNumber}`;
      colWidthClass = `w-1/${colsNumber}`;
    }
    
    otherOptions = options.slice();

    firstOptions = options.filter((option) => {
      return option.idOption === `${selectedSession.productCode}_900`;
    });
    mandatoryOptions = options.filter((option) => {
      return option.type.mandatory === true;
    });

    for (var i = 0; i < otherOptions.length; i++) {
      const firstOption = firstOptions.find((firstOption) => {
        return firstOption.idOption === otherOptions[i].idOption;
      });

      const mandatoryOption = mandatoryOptions.find((mandatoryOption) => {
        return mandatoryOption.idOption === otherOptions[i].idOption;
      });

      if (firstOption || mandatoryOption) {
        otherOptions.splice(i, 1);
      }
    }
  };

  $: {
    renderTable(selectedSession);
  }
</script>

<!-- <div class="w-2/3" />
<div class="w-1/3" />
<div class="w-2/4" />
<div class="w-1/4" />
<div class="w-2/5" />
<div class="w-1/5" />
<div class="w-2/6" />
<div class="w-1/6" /> -->

{#if packages.length > 0 && options.length > 0}
  <div class="upselling-packages-table">
    <div class="flex option">
      <div class={classNames(firstColWidthClass)}>
        {#if isSinglePackage}
          <div class="package-option">
            <div>Quota di partecipazione</div>
          </div>
        {/if}
      </div>
      {#each packages as sessionPackage}
        <div class={classNames(colWidthClass, 'package')}>
          <div class={classNames('package-wrap', 'package-main', `${isSinglePackage ? '' : `package-${sessionPackage.title.toLowerCase()}`}`)}>
            {#if !isSinglePackage}
              <div class="package-title">{sessionPackage.title}</div>
            {/if}
            <PackagePrice {hasVatFree} {sessionPackage} session={selectedSession} {showPriceWithIva} />
          </div>
        </div>
      {/each}
    </div>
    {#each mandatoryOptions as option}
      <div class="flex option">
        <div class={classNames(firstColWidthClass)}>
          <div class="package-option">
            <div>{option.title}</div>
            <TooltipDesktop title={option.title} message={option.description} />
          </div>
        </div>
        {#each packages as sessionPackage}
          <div class={classNames(colWidthClass, 'package')}>
            <div class="package-wrap">
              {#if sessionPackage.options[option.idOption] && sessionPackage.options[option.idOption].status.toLowerCase() === 'paid'}
                <OptionPrice mandatory session={selectedSession} {hasVatFree} {option} {showPriceWithIva} />
              {:else if sessionPackage.options[option.idOption] && sessionPackage.options[option.idOption].status.toLowerCase() === 'included'}
                <span class="checkmark">
                  <Icon icon="check" />
                </span>
              {:else}
                <div>&#8212;</div>
              {/if}
            </div>
          </div>
        {/each}
      </div>
    {/each}

    {#each firstOptions as option}
      <div class="flex option relative greenbox">
        <div class={classNames(firstColWidthClass)}>
          <div class="package-option">
            <div class="flex">
              <span class="leaf-icon mr-2">
                <Icon icon="leaf" size="middle" />
              </span>
              <span>{option.title}</span>
            </div>
            <TooltipDesktop title={option.title} message={option.description} />
          </div>
        </div>
        {#each packages as sessionPackage}
          <div class={classNames(colWidthClass, 'package')}>
            <div class="package-wrap">
              {#if sessionPackage.options[option.idOption] && sessionPackage.options[option.idOption].status.toLowerCase() === 'paid'}
                <OptionPrice label="Extra" session={selectedSession} {hasVatFree} {option} {showPriceWithIva} />
              {:else if sessionPackage.options[option.idOption] && sessionPackage.options[option.idOption].status.toLowerCase() === 'included' && option.priceNoVat < 0}
                <OptionPrice mandatory session={selectedSession} {hasVatFree} {option} {showPriceWithIva} />
              {:else if sessionPackage.options[option.idOption] && sessionPackage.options[option.idOption].status.toLowerCase() === 'included'}
                <span class="checkmark">
                  <Icon icon="check" />
                </span>
              {:else}
                <div>&#8212;</div>
              {/if}
            </div>
          </div>
        {/each}
      </div>
    {/each}
    {#each otherOptions as option}
      <div class="flex option">
        <div class={classNames(firstColWidthClass)}>
          <div class="package-option">
            <div>{option.title}</div>
            <TooltipDesktop title={option.title} message={option.description} />
          </div>
        </div>
        {#each packages as sessionPackage}
          <div class={classNames(colWidthClass, 'package')}>
            <div class="package-wrap">
              {#if sessionPackage.options[option.idOption] && sessionPackage.options[option.idOption].status.toLowerCase() === 'paid'}
                <OptionPrice label="Extra" session={selectedSession} {hasVatFree} {option} {showPriceWithIva} />
              {:else if sessionPackage.options[option.idOption] && sessionPackage.options[option.idOption].status.toLowerCase() === 'included'}
                <span class="checkmark">
                  <Icon icon="check" />
                </span>
              {:else}
                <div>&#8212;</div>
              {/if}
            </div>
          </div>
        {/each}
      </div>
    {/each}

    {#each staticOptions[1] as staticOption}
      {#if staticOption.title.toLowerCase() === 'diploma' && selectedSession.certification != null && selectedSession.certification != ''}
        <div class="flex option">
          <div class={classNames(firstColWidthClass)}>
            <div class="package-option">
              <div>{staticOption.title}</div>
              <TooltipDesktop title={staticOption.title} message={staticOption.description} />
            </div>
          </div>
          {#each packages as sessionPackage}
            {#if staticOption.packages[sessionPackage.title.toLowerCase()]}
              <div class={classNames(colWidthClass, 'package')}>
                <div class="package-wrap">
                  {#if staticOption.packages[sessionPackage.title.toLowerCase()].status.toLowerCase() === 'paid'}
                    <OptionPrice label="Extra" session={selectedSession} {hasVatFree} option={staticOption.packages[sessionPackage.title.toLowerCase()]} {showPriceWithIva} />
                  {:else if staticOption.packages[sessionPackage.title.toLowerCase()].status.toLowerCase() === 'included'}
                    <span class="checkmark">
                      <Icon icon="check"/>
                    </span>
                  {:else}
                    <div>&#8212;</div>
                  {/if}
                </div>
              </div>
            {/if}
          {/each}
        </div>
      {/if}
      {#if staticOption.title.toLowerCase() === 'stage' && selectedSession.stage}
        <div class="flex option">
          <div class={classNames(firstColWidthClass)}>
            <div class="package-option">
              <div>{staticOption.title}</div>
              <TooltipDesktop title={staticOption.title} message={staticOption.description} />
            </div>
          </div>
          {#each packages as sessionPackage}
            {#if staticOption.packages[sessionPackage.title.toLowerCase()]}
              <div class={classNames(colWidthClass, 'package')}>
                <div class="package-wrap">
                  {#if staticOption.packages[sessionPackage.title.toLowerCase()].status.toLowerCase() === 'paid'}
                    <OptionPrice label="Extra" session={selectedSession} {hasVatFree} option={staticOption.packages[sessionPackage.title.toLowerCase()]} {showPriceWithIva} />
                  {:else if staticOption.packages[sessionPackage.title.toLowerCase()].status.toLowerCase() === 'included'}
                    <span class="checkmark">
                      <Icon icon="check" />
                    </span>
                  {:else}
                    <div>&#8212;</div>
                  {/if}
                </div>
              </div>
            {/if}
          {/each}
        </div>
      {/if}
      {#if staticOption.title.toLowerCase() === 'servizio placement' && selectedSession.placement}
        <div class="flex option">
          <div class={classNames(firstColWidthClass)}>
            <div class="package-option">
              <div>{staticOption.title}</div>
              <TooltipDesktop title={staticOption.title} message={staticOption.description} />
            </div>
          </div>
          {#each packages as sessionPackage}
            {#if staticOption.packages[sessionPackage.title.toLowerCase()]}
              <div class={classNames(colWidthClass, 'package')}>
                <div class="package-wrap">
                  {#if staticOption.packages[sessionPackage.title.toLowerCase()].status.toLowerCase() === 'paid'}
                    <OptionPrice label="Extra" session={selectedSession} {hasVatFree} option={staticOption.packages[sessionPackage.title.toLowerCase()]} {showPriceWithIva} />
                  {:else if staticOption.packages[sessionPackage.title.toLowerCase()].status.toLowerCase() === 'included'}
                    <span class="checkmark">
                      <Icon icon="check" />
                    </span>
                  {:else}
                    <div>&#8212;</div>
                  {/if}
                </div>
              </div>
            {/if}
          {/each}
        </div>
      {/if}
    {/each}
  </div>
  {#if showPriceWithIva}
    <div class="flex justify-end text-xs text-gray-600 px-4 py-2">
      * Prezzi IVA inclusa
    </div>
  {/if}
{/if}

<style type="text/scss" lang="scss" scoped>
  .greenbox {
    &::after {
      @apply w-full h-full block absolute;
      @apply top-0 left-0;
      @apply rounded-lg;
      @apply pointer-events-none;

      content: '';
      background-color: #4e8480;
      opacity: 0.15;
    }
  }

  .upselling-packages-table {
    .option:last-child {
      .package-wrap {
        @apply rounded-b;
      }
    }
  }

  .package {
    @apply px-2;
  }

  .package-option {
    @apply min-h-full;
    @apply pl-4 pr-6;
    @apply font-semibold;
    @apply flex justify-between items-center;
  }
  .package-wrap {
    @apply min-h-full;
    @apply bg-white;
    @apply px-2 py-4;
    @apply text-center;
    @apply flex items-center justify-center;

    &.package-main {
      @apply flex-col items-start;
      @apply rounded-t;
      @apply px-4 py-4;
      @apply border-b border-gray-100;
      @apply text-left;

      &.package-easy {
        @apply border-t-8;
        border-top-color: #d3d3d3;
      }
      &.package-smart {
        @apply border-t-8;
        border-top-color: #b2e8ff;
      }
      &.package-flex {
        @apply border-t-8;
        border-top-color: #ffe08c;
      }
      &.package-full {
        @apply border-t-8;
        border-top-color: #3e3e3e;
      }
    }
  }

  .package-title {
    @apply transition-all duration-300;
    @apply flex-grow;
    @apply mx-auto;
    @apply font-bold text-lg;
  }

  .checkmark {
    @apply w-5 h-5;
    @apply rounded-full;
    @apply text-white;
    @apply flex items-center justify-center;
    @apply mx-auto;

    background-color: #4e8480;
  }

  .leaf-icon {
    @apply flex;

    color: #bdddd3;
  }
</style>
